module.exports = __webpack_public_path__ + "img/bg-banner-sp-ug.f25858ee.png";